module.exports = __webpack_public_path__ + "static/soc1-b14c4aa7cb583ee163febc295abc760b.png";